export const GET_HOSTS_REQUEST="GET_HOSTS_REQUEST"
export const GET_HOSTS_SUCCESS="GET_HOSTS_SUCCESS"
export const GET_HOSTS_FAILURE="GET_HOSTS_FAILURE"
export const FILTER_BY_LANGUAGE="FILTER_BY_LANGUAGE"
export const FILTER_BY_VERIFIED="FILTER_BY_VERIFIED" 
export const FILTER_BY_REFRENCES="FILTER_BY_REFRENCES"
export const FILTER_BY_ACCEPTING_GUESTS="FILTER_BY_ACCEPTING_GUESTS"
export const FILTER_BY_CITY="FILTER_BY_CITY"